import mui.material.Box
import mui.system.sx
import react.FC
import react.Props
import react.create
import uz.ferro.erp.Colors
import uz.ferro.erp.pages.MAX_PAGE_AREA
import uz.ferro.erp.ui.AppTextMedium
import uz.ferro.erp.util.styleInMobile
import web.cssom.Auto
import web.cssom.px


external interface HeaderTitleViewProps : Props {
    var title: String
}

val HeaderTitleView = FC<HeaderTitleViewProps> { props ->
    val title = props.title

    Box {
        sx {
            backgroundColor = Colors.accentColor
        }

        Box {
            sx {
                maxWidth = MAX_PAGE_AREA
                marginLeft = Auto.auto
                marginRight = Auto.auto
                padding = 16.px
            }

            AppTextMedium {
                text = title
                color = Colors.white
                sx {
                    fontSize = styleInMobile(22.px, 28.px)
                }
            }
        }
    }
}